var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHealthsocial(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 800",
    style: {
      enableBackground: "new 0 0 800 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2ED87B;}\n\t.st1{fill:#1197EA;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 427.6,
    y: 11,
    className: "st0",
    width: 49.81,
    height: 104.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.4,
    y: 115.06,
    className: "st0",
    width: 54.2,
    height: 49.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.53,
    y: 115.06,
    className: "st0",
    width: 104.06,
    height: 49.81
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "373.4,268.89 427.6,268.89 427.6,219.07 323.54,219.07 323.54,268.89 323.54,323.09 373.4,323.09  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 477.41,
    y: 219.07,
    className: "st0",
    width: 54.2,
    height: 49.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 427.6,
    y: 476.96,
    className: "st0",
    width: 49.81,
    height: 54.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.4,
    y: 531.11,
    className: "st0",
    width: 54.2,
    height: 49.86
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.39,
    y: 531.11,
    className: "st0",
    width: 54.2,
    height: 49.86
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "323.54,684.99 323.54,789 373.4,789 373.4,684.99 427.6,684.99 427.6,635.13 323.54,635.13  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 477.41,
    y: 635.13,
    className: "st0",
    width: 104.06,
    height: 49.86
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "269.39,268.89 269.39,219.07 219.53,219.07 219.53,268.89 219.53,323.09 269.39,323.09  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 323.09,
    className: "st0",
    width: 104.01,
    height: 49.86
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.37,
    y: 323.09,
    className: "st0",
    width: 54.15,
    height: 49.86
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "115.51,476.96 115.51,580.97 165.37,580.97 165.37,476.96 219.53,476.96 219.53,427.1 115.51,427.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "269.39,476.96 323.59,476.96 373.4,476.96 373.4,427.1 323.59,427.1 269.39,427.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 635.63,
    y: 219.07,
    className: "st0",
    width: 49.86,
    height: 104.01
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "531.61,372.95 531.61,323.09 477.41,323.09 427.6,323.09 427.6,372.95 477.41,372.95  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 581.47,
    y: 323.09,
    className: "st0",
    width: 54.15,
    height: 49.86
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "531.61,476.96 531.61,531.11 531.61,580.97 581.43,580.97 581.47,580.97 581.47,476.96  635.63,476.96 635.63,427.1 531.61,427.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 685.49,
    y: 427.1,
    className: "st0",
    width: 104.01,
    height: 49.86
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 269.39,
    y: 219.06,
    className: "st1",
    width: 54.15,
    height: 49.86
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "427.55,115.05 427.55,164.86 427.55,219.06 427.55,268.88 427.55,268.92 427.55,323.08 427.6,323.08  477.41,323.08 477.41,268.92 477.41,268.88 477.41,219.06 477.41,164.86 581.43,164.86 581.43,115.05 477.41,115.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "323.54,115.05 323.54,164.86 323.54,219.06 373.4,219.06 373.4,164.86 373.4,115.05 373.4,11.04  323.54,11.04  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.53,
    y: 635.12,
    className: "st1",
    width: 104.01,
    height: 49.86
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "427.55,531.1 427.55,580.96 427.55,635.12 427.55,684.98 427.55,788.99 477.41,788.99 477.41,684.98  477.41,635.12 477.41,580.96 531.61,580.96 531.61,531.1 477.41,531.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "323.54,531.1 323.54,580.96 323.54,635.12 373.4,635.12 373.4,580.96 373.4,531.1 373.4,476.95  323.54,476.95  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 427.09,
    className: "st1",
    width: 104.01,
    height: 49.86
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "269.39,323.08 219.53,323.08 219.53,372.94 219.53,427.09 219.53,476.95 219.53,531.1 219.53,580.96  269.39,580.96 269.39,531.1 269.39,476.95 269.39,427.09 269.39,372.94 323.54,372.94 373.4,372.94 373.4,323.08 323.54,323.08  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "115.51,323.08 115.51,372.94 115.51,427.09 165.37,427.09 165.37,372.94 165.37,323.08  165.37,219.06 115.51,219.06  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "427.55,427.09 427.55,476.95 477.41,476.95 531.61,476.95 531.61,427.09 477.41,427.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "685.44,323.08 635.63,323.08 635.63,372.94 635.63,427.09 635.63,476.95 635.63,580.96  685.44,580.96 685.44,476.95 685.44,427.09 685.44,372.94 789.5,372.94 789.5,323.08  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "531.61,268.88 531.61,323.08 531.61,372.94 531.61,427.09 581.43,427.09 581.43,372.94  581.43,323.08 581.43,268.88 581.43,219.06 531.61,219.06  "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthsocial);
export default __webpack_public_path__ + "static/media/healthsocial.f53781526cd5633ee8b5ea96d50fb02d.svg";
export { ForwardRef as ReactComponent };